import React from 'react';

import Email from '../components/email';

const EmailPage = () => {
    return (
        <Email />
    )
}

export default EmailPage;


// WEBPACK FOOTER //
// ./src/containers/email-page.js